import initializeUploadDropArea from 'upload';

window.addEventListener('load', () => {
  initializeUploadDropArea();
});
